import React from "react";
import { Space, Typography } from "antd";
import Legend from "./Legend";
import "./legend.css";

const { Text } = Typography;

const statusItems = [
  { label: "Approved", borderColor: "#52c41a", background: "#f6ffed" },
  { label: "Pending Approval", borderColor: "#1d39c4", background: "#f0f5ff" },
  { label: "Unsubmitted", borderColor: "#6A1B9A", background: "#F3E5F5" },
  { label: "Edit Request", borderColor: "#d46b08", background: "#fff7e6" },
];

const filledByItems = [
  { label: "Volunteer", borderColor: "#8c8c8c", background: "#fafafa", circle: false },
  { label: "Volunteer Coordinator", borderColor: "#8c8c8c", background: "#fafafa", circle: true },
];

const LegendWrapper = () => {
  return (
    <div className="legend-wrapper" aria-label="Care plan legend">
      <div className="legend-row">
        <Text className="legend-title">Status:</Text>
        <Space wrap className="legend-items" role="list">
          {statusItems.map((item) => (
            <Legend
              key={item.label}
              borderColor={item?.borderColor}
              background={item?.background}
              label={item.label}
            />
          ))}
        </Space>
      </div>

      <div className="legend-row">
        <Text className="legend-title">Submitted By:</Text>
        <Space wrap className="legend-items" role="list">
          {filledByItems.map((item) => (
            <Legend
              key={item.label}
              borderColor={item?.borderColor}
              background={item?.background}
              label={item.label}
              circle={item.circle}
            />
          ))}
        </Space>
      </div>
    </div>
  );
};

export default LegendWrapper;
